<template>
  <el-dropdown class="user-menu" trigger="click" @command="handleCommand">
    <div class="user-menu-trigger">
      <span class="user-name">{{ displayName }}</span>
      <el-icon class="el-icon--right"><ArrowDown /></el-icon>
    </div>
    <template #dropdown>
      <el-dropdown-menu>
        <div class="user-info-header">
          <div class="user-fullname">{{ user.name || user.email }}</div>
          <div class="user-email">{{ user.email }}</div>
          <el-tag v-if="user.role" size="small" type="info">{{ user.role }}</el-tag>
        </div>
        <el-dropdown-item divided command="profile">
          Profil Saya
        </el-dropdown-item>
        <el-dropdown-item divided command="logout">
          Keluar
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>


  <!-- Profile Dialog -->
  <el-dialog
    v-model="profileDialog"
    title="Profil Saya"
    width="500px"
    :close-on-click-modal="false"
  >
    <el-descriptions :column="1" border>
      <el-descriptions-item label="Nama">
        {{ user.name || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="Email">
        {{ user.email }}
      </el-descriptions-item>
      <el-descriptions-item label="Peran">
        <el-tag>{{ user.role || '-' }}</el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="Unit">
        {{ user.unit_name || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="Hak Akses">
        <div class="permission-list">
          <el-tag
            v-for="perm in userPermissions"
            :key="perm"
            size="small"
            style="margin: 2px"
          >
            {{ perm }}
          </el-tag>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <template #footer>
      <el-button @click="profileDialog = false">Tutup</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router'
import { ArrowDown } from '@element-plus/icons-vue'

export default defineComponent({
  name: 'UserMenu',
  components: {
    ArrowDown
  },
  setup() {
    const router = useRouter()
    const user = ref({})
    const permissions = ref([])
    const profileDialog = ref(false)

    // Initialize user data
    if (localStorage.user) {
      const userData = JSON.parse(localStorage.user)
      user.value = userData
      
      // Extract permissions for Web Putra module
      userData.permissions?.forEach((role) => {
        if (role.module_name === "Web Putra") {
          permissions.value = role.permissions.split(",")
        }
      })
    }


    // Computed properties
    const displayName = computed(() => {
      return user.value.name || user.value.email?.split('@')[0] || 'Pengguna'
    })


    const userPermissions = computed(() => {
      return permissions.value.filter(p => p && p.trim())
    })

    // Methods
    const hasPermission = (permission) => {
      return permissions.value.indexOf(permission) >= 0
    }

    const handleCommand = (command) => {
      switch (command) {
        case 'profile':
          profileDialog.value = true
          break
        case 'logout':
          handleLogout()
          break
      }
    }

    const handleLogout = () => {
      ElMessageBox.confirm(
        'Apakah anda yakin akan keluar?',
        'Konfirmasi Keluar',
        {
          confirmButtonText: 'Ya, Keluar',
          cancelButtonText: 'Batal',
          type: 'warning'
        }
      ).then(() => {
        // Clear auth data
        localStorage.removeItem('auth_token')
        localStorage.removeItem('user')
        
        // Clear store if using Vuex
        // store.commit('clearAuth')
        
        ElMessage.success('Anda telah berhasil keluar')
        router.push('/masuk')
      }).catch(() => {
        // User cancelled
      })
    }


    return {
      user,
      permissions,
      profileDialog,
      displayName,
      userPermissions,
      hasPermission,
      handleCommand
    }
  }
})
</script>

<style scoped>
.user-menu {
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
}

.user-menu-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  height: 100%;
  color: #FBFDFF;
  transition: background-color 0.3s;
}

.user-menu-trigger:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.user-name {
  font-size: 14px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-info-header {
  padding: 20px;
  background-color: #f5f7fa;
  margin: -12px -20px 0 -20px;
  border-bottom: 1px solid #e4e7ed;
}

.user-fullname {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-email {
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.permission-list {
  max-height: 200px;
  overflow-y: auto;
  padding: 4px 0;
}

:deep(.el-dropdown-menu) {
  width: 260px;
  padding: 0;
}

:deep(.el-dropdown-menu__item) {
  padding: 14px 20px;
  font-size: 14px;
  line-height: 1.5;
  transition: background-color 0.2s;
}

:deep(.el-dropdown-menu__item:hover) {
  background-color: #f5f7fa;
}

:deep(.el-dropdown-menu__item.is-divided) {
  margin-top: 6px;
  border-top: 1px solid #e4e7ed;
  padding-top: 14px;
}

:deep(.el-dropdown-menu__item i) {
  margin-right: 8px;
}
</style>